// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuarantineSummary
 */
export interface QuarantineSummary {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof QuarantineSummary
     */
    byRule?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof QuarantineSummary
     */
    byStage?: { [key: string]: number; };
    /**
     * 
     * @type {Array<string>}
     * @memberof QuarantineSummary
     */
    dataColumns?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof QuarantineSummary
     */
    totalFailed: number;
}

/**
 * Check if a given object implements the QuarantineSummary interface.
 */
export function instanceOfQuarantineSummary(value: object): value is QuarantineSummary {
    if (!('totalFailed' in value) || value['totalFailed'] === undefined) return false;
    return true;
}

export function QuarantineSummaryFromJSON(json: any): QuarantineSummary {
    return QuarantineSummaryFromJSONTyped(json, false);
}

export function QuarantineSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuarantineSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'byRule': json['byRule'] == null ? undefined : json['byRule'],
        'byStage': json['byStage'] == null ? undefined : json['byStage'],
        'dataColumns': json['dataColumns'] == null ? undefined : json['dataColumns'],
        'totalFailed': json['totalFailed'],
    };
}

export function QuarantineSummaryToJSON(json: any): QuarantineSummary {
    return QuarantineSummaryToJSONTyped(json, false);
}

export function QuarantineSummaryToJSONTyped(value?: QuarantineSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'byRule': value['byRule'],
        'byStage': value['byStage'],
        'dataColumns': value['dataColumns'],
        'totalFailed': value['totalFailed'],
    };
}
